import React, { useState, useEffect } from "react";
import { Typography, Button } from "antd";
import UserMangementApis from "api/userManagement";
import UserMemberCard from "./UserMemberCard";
import Utils from "./utils";
import UserModal from "./UserModal";

const { Text } = Typography;
const { LineBreak, Spinner } = Utils;

const Header = ({ numOfAdmins, numOfEmployees, handleNewUser }) => {
	return (
		<div
			style={{
				flexDirection: "row",
				display: "flex",
				justifyContent: "space-between",
			}}
		>
			<div style={{ flexDirection: "column", display: "flex" }}>
				<Text strong style={{ color: "#1D2624", marginBottom: "0.3rem" }}>
					USERS
				</Text>
				<Text style={{ color: "#4F5655" }}>
					{`${numOfAdmins} Admins  | ${numOfEmployees} Employees`}
				</Text>
			</div>
			<div
				style={{
					flexDirection: "row",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Button
					onClick={handleNewUser}
					style={{
						fontSize: "14px",
						fontWeight: 800,
						border: "1px solid #0B7764",
						backgroundColor: "#F0F8F6",
						color: "#0B7764",
					}}
				>
					Add New
				</Button>
			</div>
		</div>
	);
};

export default function UserMemberDetails({ countryCodes }) {
	const [userMembers, setUserMembers] = useState([]);
	const [isModalVisible, toggleModal] = useState(false);
	const [modalType, setModalType] = useState();
	const [currentUser, setCurrentUser] = useState({});
	const [num, setNum] = useState([]);
	const [loading, setLoading] = useState(true);

	const fetchUsers = () => {
		UserMangementApis.getUserMembers()
			.then((res) => {
				const data = res.data.data;
				const numOfAdmins = data.filter((user) => user?.isAdmin)?.length;
				const numOfEmployees = data.length - numOfAdmins;
				setUserMembers(Utils.transformUserMemberData(data));
				setNum({ numOfAdmins, numOfEmployees });
				setLoading(false);
			})
			.catch((e) => {
				Utils.ToastError(e);
				setLoading(false);
			});
	};

	useEffect(() => {
		fetchUsers();
	}, []);

	const handleNewUser = () => {
		toggleModal(true);
		setModalType("add");
	};

	const handleEditUser = (user) => {
		toggleModal(true);
		setCurrentUser(user);
		setModalType("edit");
	};

	const handleRemoveUser = () => {};

	const closeModal = (fetchDataAgain) => {
		setCurrentUser({});
		if (fetchDataAgain) {
			setLoading(true);
			fetchUsers();
		}
		toggleModal(false);
	};

	if (loading) return <Spinner />;
	return (
		<div style={{ width: window.innerWidth > 900 ? "70%" : "100%" }}>
			<Header
				numOfAdmins={num.numOfAdmins}
				numOfEmployees={num.numOfEmployees}
				handleNewUser={handleNewUser}
			/>
			{userMembers.map((user, index) => {
				return (
					<div key={`user_${index}_${user.userId}`}>
						<LineBreak />
						<UserMemberCard
							user={user}
							handleRemoveUser={handleRemoveUser}
							handleEditUser={handleEditUser}
						/>
					</div>
				);
			})}
			{isModalVisible && (
				<UserModal
					visible={isModalVisible}
					modalType={modalType}
					closeModal={closeModal}
					currentUser={currentUser}
					countryCodes={countryCodes}
				/>
			)}
		</div>
	);
}
